module.exports = __webpack_public_path__ + "static/media/30-dni.ae845519.svg";